export default {
  name: "FormErrors",
  props: {
    visible: Boolean,
    formErrors: Array,
  },
  data() {
    return {};
  },
};
